import { SignUpTemplate } from 'layouts/SignUpTemplate';
import * as React from 'react';
import { useSearchParams } from 'react-router-dom';
import { CodeForm } from './components/CodeForm';
import { Email } from './components/Email';

export const EmailConfirmation: React.FC = () => {
  const [params] = useSearchParams();
  const email = params.get('email');
  return (
    <SignUpTemplate>
      <div className="text-center flex flex-col items-center justify-center pt-16 space-y-12">
        <div className="space-y-4">
          <h1 className="font-bold">Check your email for a code</h1>
          <h4 className="font-medium max-w-[500px]">
            We&rsquo;ve sent a 6-character code to {email || 'your email'}. The code expires
            shortly, so please enter it soon.
          </h4>
        </div>
        <CodeForm />
        <div className="pt-16 text-gray-600">
          <div className="flex items-center justify-center space-x-4">
            <Email provider="gmail" />
            <Email provider="outlook" />
          </div>
          <h5>Can&rsquo;t find your code? Check your spam folder!</h5>
        </div>
      </div>
    </SignUpTemplate>
  );
};
EmailConfirmation.displayName = 'Pages.EmailConfirmation';
